import React from 'react';
import { Button, Card, Col, Container, Row, Nav, Navbar, Table, Image, CardGroup } from 'react-bootstrap';
import { ArrowRight, ArrowUpRight, Check, X } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import moreBackground from './more-is-better.svg';
import YouHaveTheBest from './you-have-the-best-bot.png';
import CurrentPlan from './current-plan.png';
import NinePlan from './999-plan.png';
import premiumStars from './stars-premium.svg';
import imagineMailing from '../../assets/img/enhanced-landing.png';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentPlan, updateNextPlan, fetchPackagesDetail, blankCurrentPlan } from '../../redux/slices/EnhanceDisputeSlice';
import { fetchNotification, setNotifcationBedge } from '../../redux/slices/CommonSlice';
import { blankGetAllReportData, getAllReport, reateDisputeLatter } from '../../redux/slices/ReportSlice';
import $ from 'jquery';
import NotyfContext from '../../contexts/NotyfContext';
import OnboardingSteps from '../../components/new/OnboardingSteps';
import EnhancedLPImage from '../../assets/img/enhanced-landing.png';
import EnhancedFactory from '../../assets/img/disputely-enhanced-factory.png';
import Waving from '../../assets/img/waving-hi.png';
import DiyStandard from '../../assets/img/standard-diy.png';
import WdfuStandard from '../../assets/img/standard-wd4u.png';
import MoreIsBetter from './more-is-better-bot.png';
import BureauGroup from './dispute-group-1.png';
import OneArmHold from '../../assets/img/one-arm-bot-sign.png';
import Experian from '../../assets/img/brands/experian.svg';
import Equifax from '../../assets/img/brands/equifax.svg';
import TransUnion from '../../assets/img/brands/transunion.svg';
import Loader from '../../components/Loader';
import { useNavigate } from 'react-router-dom';
import CDIA from '../../assets/img/cdia.png';
import CFPB from '../../assets/img/cfpb.png';
import Creditor from '../../assets/img/creditor.png';
import USFTC from '../../assets/img/usftc.png';
import Chex from '../../assets/img/chexsystems.png';
import LexisNexis from '../../assets/img/lexisnexis.svg';
import Pacer from '../../assets/img/pacer.png';

const EnhanceCurrentDisputes = ({ onPlanClick, disputelyMailed }) => {
  const notyf = React.useContext(NotyfContext);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const packages = useSelector(state => state.enhanceDispute.packages);
  const packagesDetail = useSelector(state => state.enhanceDispute.packagesDetail);
  const currentPlanStatus = useSelector(state => state.enhanceDispute.currentPlanStatus);
  const currentPlanStatusMsg = useSelector(state => state.enhanceDispute.currentPlanStatusMsg);

  const reportStatus = useSelector(state => state.reports.getAllReportStatus);
  const getAllReportData = useSelector(state => state.reports.getAllReportData);

  React.useEffect(() => {
    let obj = {
      clientId: 1,
      roundid: 1,
    };
    dispatch(blankCurrentPlan());
    dispatch(fetchCurrentPlan());
    dispatch(getAllReport(obj));
    dispatch(fetchPackagesDetail());
  }, []);

  React.useEffect(() => {
    return () => {
      dispatch(blankGetAllReportData());
    };
  }, []);

  const updatePlan = planId => {
    navigate(`/checkout-disputes/${planId == 1 ? 'standard' : 'enhanced'}`);
  };

  if (reportStatus === 'loading') {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <style>
        {`
          .steps {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
            position: relative;
          }
          .step-button {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: none;
            background-color: var(--prm-gray);
            transition: .4s;
          }
          .step-button[aria-expanded="true"] {
            width: 25px;
height: 25px;
font-size: 12px;
          }
          .done {
            background-color: var(--prm-color);
            color: #fff;
          }
          .step-item {
            z-index: 10;
            text-align: center;
            margin-top: 1.5rem;
          }
          #progress {
            -webkit-appearance: none;
            position: absolute;
            width: 100%;
            z-index: 5;
            border: #C8CCDF dashed;
            border-width: 3px 0px 0px 0px;
            top: 6.75rem;
          }
          /* to customize progress bar */

          #progress::-webkit-progress-value {
            background-color: var(--prm-color);
            transition: .5s ease;
          }
          #progress::-webkit-progress-bar {
            background-color: var(--prm-gray);
          }
          .step-title {
            width: 120px;
            color: #7C84A5;
            font-weight: 400;
            text-align: center;
            margin-bottom:1.5rem;
          }
          .completed .step-title {
            text-align: center;
            font-weight: 500;
            color: #000E4E
          }
          .active .step-title {
            font-weight: 500;
            color: #0076FF
          }
          .shadow-more {
            box-shadow: 0 6px 40px 0 rgb(var(--bs-primary-rgb), 0.5) !important;
          }

          `}
      </style>
      <Container fluid className='container-fluid-1335 pb-5'>
        <div className='row'>
          <h1 style={{ textAlign: 'center', margin: '1rem', marginBottom: '3rem' }}>Upgrade Your Plan</h1>
        </div>

        <div className='card-group-wrapper mt-5'>
          <CardGroup>
            {/* ************* STANDARD WITH MAILING ************* */}
            {disputelyMailed !== undefined && !disputelyMailed && <Card
              id='standardMailing'
              style={{ paddingTop: '2.5rem' }}
              className={`border-0 shadow mx-2 d-flex flex-column`}
              onClick={() => {
                updatePlan(1);
                onPlanClick && onPlanClick();
              }}>
              <Card.Header className='py-3 border-0 bg-white rounded-4'>
                <h3 className='text-center'>Standard with Mailing</h3>
                <div className='text-center'>We do the mailing for you! Expedited Processing &amp; Mailing w/ Disputely</div>
              </Card.Header>
              <Card.Img className='fixed-height p-3' variant='top' src={WdfuStandard} />
              <Card.Header className='py-3 border-0 bg-white rounded-4' style={{ minHeight: '300px' }}>
                <h3 className='mb-3 text-center'>Dispute with the 3 Major Bureaus.</h3>
                <Col className='d-flex flex-column justify-content-center align-items-center'>
                  <Image src={Experian} alt='Experian' className='m-auto w-50 my-3' />
                  <Image src={Equifax} alt='Equifax' className='m-auto w-50 mb-3' />
                  <Image src={TransUnion} alt='TransUnion' className='m-auto w-50' />
                </Col>
              </Card.Header>
              <Card.Body>
                <Card className='mb-0 rounded-3 border border-4 shadow h-100'>
                  <Card.Body className='bg-white p-0 rounded-3'>
                    <div className='d-flex flex-row px-3 py-3'>
                      <div href='#home' className='navbar-brand'>
                        <div className='bg-light-gray lh-1 p-1 rounded-5'>
                          <Check className='m-auto p-1 bg-white text-secondary rounded-circle h-auto border border-secondary border-1' width={30} height={30} strokeWidth={5} color={'var(--bs-secondary)'} />
                        </div>
                      </div>
                      <span className='me-auto ms-3 h3 mb-0 text-secondary navbar-brand'>Standard with Mailing</span>
                      <button type='button' className='text-secondary border-0 py-1 px-3 bg-opacity-25 btn btn-light'>
                        ${packages[1] && packages[1]}
                      </button>
                    </div>
                    <hr className='w-90 mx-auto opacity-25 text-light-gray' />
                    <Row className='row px-5 pb-4 pt-2'>
                      <Col xs={12} className='rounded-4 mx-auto bg-light p-3'>
                        <p className='mb-1 fs-5 text-light-gray'>You will get</p>
                        <ul>
                          <li>Expedited Processing and Mailing</li>
                          <li>{packagesDetail.length > 0 && packagesDetail[0].total_negative} Negative items (Dispute)</li>
                          <li>{packagesDetail.length > 0 && packagesDetail[0].total_destination} Major Reporting Agencies (With me)</li>
                          <li>{packagesDetail.length > 0 && packagesDetail[0].total_letter} Total Letters</li>
                          <li>Credit Bureau Disputes</li>
                          <li>Dispute Letter (Mail Only)</li>
                          <li>Personal Information Disputes Not Included</li>
                        </ul>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Card.Body>

              <Card.Footer className='p-0'>
                <Button variant='primary' size='lg' className='w-100'>
                  Mail It For Me!
                </Button>
              </Card.Footer>
            </Card>}
            {/* ************* ENHANCED ************* */}
            <Card
              id='enhanced'
              style={{ paddingTop: '2.5rem' }}
              className={`border-0 shadow mx-2 d-flex flex-column position-relative mt-5`}
              onClick={() => {
                updatePlan(2);
                onPlanClick && onPlanClick();
              }}>
              <Image src={MoreIsBetter} alt='More Is Better' className='' style={{ width: '220px', position: 'absolute', top: '-150px', left: '25%' }} />
              <Card.Header className='py-3 border-0 bg-white rounded-4'>
                <h3 className='text-center'>Enhanced</h3>
                <div className='text-center '>+ Expedited Processing & Mailing Included</div>
                <div className='text-center'>The most comprehensive, customized dispute process on the planet.</div>
              </Card.Header>
              <Card.Img className='fixed-height p-3' variant='top' src={EnhancedFactory} />
              <Card.Header className='py-3 border-0 bg-white rounded-4' style={{ minHeight: '300px' }}>
                <h3 className='mb-3 text-center'>Expanded Bureau Disputes</h3>
                <Row className='d-flex flex-row justify-content-center align-items-center my-3'>
                  <Col xs={4}>
                    <Image src={Experian} alt='Experian' className='mx-auto w-100' />
                  </Col>
                  <Col xs={4}>
                    <Image src={Equifax} alt='Equifax' className='mx-auto w-100' />
                  </Col>
                  <Col xs={4}>
                    <Image src={TransUnion} alt='TransUnion' className='mx-auto w-100' />
                  </Col>
                </Row>
                <Row className='d-flex flex-row justify-content-center align-items-center mb-3'>
                  <Col xs={4}>
                    <Image src={CDIA} alt='Experian' className='mx-auto w-100' />
                  </Col>
                  <Col xs={4}>
                    <Image src={CFPB} alt='Equifax' className='mx-auto w-100' />
                  </Col>
                  <Col xs={4}>
                    <Image src={Creditor} alt='TransUnion' className='mx-auto w-75' />
                  </Col>
                </Row>
                <Row className='d-flex flex-row justify-content-center align-items-center'>
                  <Col xs={4}>
                    <Image src={Chex} alt='Experian' className='mx-auto w-100' />
                  </Col>
                  <Col xs={4}>
                    <Image src={LexisNexis} alt='Equifax' className='mx-auto w-100' />
                  </Col>
                  <Col xs={4}>
                    <Image src={Pacer} alt='TransUnion' className='mx-auto w-100' />
                  </Col>
                </Row>
                <Row className='d-flex flex-row justify-content-center align-items-center'>
                  <Col xs='12' className='mx-auto my-4'>
                    <h3 className='text-center'>And More...</h3>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body>
                <Card
                  style={{
                    backgroundImage: `url(${moreBackground})`,
                    backgroundRepeat: 'no-repeat',
                  }}
                  className='mb-0 rounded-3 bg-primary shadow-more rounded-3 p-3'>
                  <Card.Body className='bg-transparent p-0 rounded-3'>
                    <nav className='p-0 shadow-none navbar navbar-expand-lg navbar-light'>
                      <Container fluid>
                        <a href='#home' className='navbar-brand'>
                          <div className='bg-light-blue lh-1 p-2 d-flex rounded-circle'>
                            <Image src={premiumStars} alt='premium stars' fill='var(--bs-primary)' className='text-primary' width={10} height={10} />
                          </div>
                        </a>
                        <span className='me-auto fw-bold mb-0 text-white navbar-brand'>Enhanced</span>
                        <a role='button' className='nav-link disabled' aria-disabled='true'>
                          <div className='text-white rounded border-0 py-1 px-3 bg-white bg-opacity-25 '>${packages[2] && packages[2]}</div>
                        </a>
                      </Container>
                    </nav>
                    <hr className='w-90 mx-auto opacity-75 text-white' />
                    <Row className='row'>
                      <div className='mx-auto bg-light bg-opacity-25 rounded-4 py-3 col-lg-10'>
                        <p className='mb-1 fs-5 text-white'>You will get</p>
                        <table className='mb-0 table table-borderless'>
                          <tbody>
                            <tr>
                              <td colSpan={1} className='h2 text-white w-10'>
                                {packagesDetail.length > 0 && packagesDetail[1].total_negative}
                              </td>
                              <td className='text-regular-18 text-white text-left'>Negative items (Dispute)</td>
                            </tr>
                            <tr>
                              <td colSpan={1} className='h2 text-white w-10'>
                                {packagesDetail.length > 0 && packagesDetail[1].total_destination}
                              </td>
                              <td className='text-regular-18 text-white text-left'>Major Reporting Agencies (With me)</td>
                            </tr>
                            <tr>
                              <td colSpan={1} className='h2 text-white w-10'>
                                {packagesDetail.length > 0 && packagesDetail[1].total_letter}
                              </td>
                              <td className='text-regular-18 text-white text-left'>Total Letters</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Row>
                    <hr className='w-90 mx-auto opacity-75 text-white' />
                    <Row>
                      <div className='mx-auto bg-light rounded-4 py-3 col-lg-10'>
                        <table className='mb-0 table table-borderless'>
                          <tbody>
                            <tr>
                              <td>
                                <svg xmlns='http://www.w3.org/2000/svg' width={30} height={30} viewBox='0 0 24 24' fill='none' stroke='var(--bs-white)' strokeWidth={3} strokeLinecap='round' strokeLinejoin='round' className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1'>
                                  <polyline points='20 6 9 17 4 12' />
                                </svg>
                              </td>
                              <td className='text-regular-18 text-primary text-left'>Expedited Personal Information Disputes</td>
                            </tr>
                            <tr>
                              <td>
                                <svg xmlns='http://www.w3.org/2000/svg' width={30} height={30} viewBox='0 0 24 24' fill='none' stroke='var(--bs-white)' strokeWidth={3} strokeLinecap='round' strokeLinejoin='round' className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1'>
                                  <polyline points='20 6 9 17 4 12' />
                                </svg>
                              </td>
                              <td className='text-regular-18 text-primary text-left'>Credit Bureau Disputes, All Bureaus</td>
                            </tr>
                            <tr>
                              <td>
                                <svg xmlns='http://www.w3.org/2000/svg' width={30} height={30} viewBox='0 0 24 24' fill='none' stroke='var(--bs-white)' strokeWidth={3} strokeLinecap='round' strokeLinejoin='round' className='m-auto p-1 bg-primary text-white rounded-circle h-auto border border-primary border-1'>
                                  <polyline points='20 6 9 17 4 12' />
                                </svg>
                              </td>
                              <td className='text-regular-18 text-primary text-left'>Dispute Letter (Mail, Fax, Email)</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Row>
                    <hr className='w-90 mx-auto opacity-75 text-white' />
                  </Card.Body>
                </Card>
              </Card.Body>

              <Card.Footer className='p-0'>
                <Button variant='primary' size='lg' className='w-100'>
                  Go Enhanced
                </Button>
              </Card.Footer>
            </Card>
          </CardGroup>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default EnhanceCurrentDisputes;
